/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { Injectable } from '@angular/core';
import { type BaseRequestOptionsArgs, type HttpResponse, HttpService } from '@dm/core';
import { type Observable } from 'rxjs';

import { DownloadService } from '../../../common/services';

@Injectable()
export class PoweronFailService {
    constructor(
        private httpService: HttpService,
        private downloadService: DownloadService,
    ) { }

    // 下发操作【打包、查询路径】
    doAction(param?, options?: BaseRequestOptionsArgs): Observable<HttpResponse> {
        const rest = this.httpService.makeUrl('poweronFail.get');
        rest.setParams(param);
        return this.httpService.get(rest, { doException: false, ...options });
    }

    // 下载日志
    download(param): void {
        const rest = this.httpService.makeUrl('poweronFail.get');
        rest.setParams(param);
        this.downloadService.downloadFile(rest);
    }

    // 获取开工失败详细信息
    getPoweronFailReson(options?: BaseRequestOptionsArgs): Observable<HttpResponse> {
        const rest = this.httpService.makeUrl('poweronFail.getPoweronFailReason');
        rest.setParams({ check: 1 });
        return this.httpService.get(rest, options);
    }
}
